import _implicitStylesheets from "./userMenuMobile.css";
import _implicitScopedStylesheets from "./userMenuMobile.scoped.css?scoped=true";
import _wdsAvatar from "wds/avatar";
import _wdsLink from "wds/link";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h4 class="user-menu-mobile__title${0}" type-style="display-7"${2}>${"t1"}</h4>`;
const $fragment2 = parseFragment`<h3 class="user-menu-mobile__name${0}" type-style="display-8"${2}>${"t1"}</h3>`;
const $fragment3 = parseFragment`<h5 class="user-menu-mobile__name${0}" type-style="display-8"${2}>${"t1"}</h5>`;
const $fragment4 = parseFragment`<a${"a0:href"} class="user-menu-mobile__link${0}"${"a0:data-testid"} type-style="body-3"${2}>${"t1"}</a>`;
const $fragment5 = parseFragment`<div class="user-menu-mobile__divider${0}"${2}></div>`;
const $fragment6 = parseFragment`<a${"a0:href"} class="user-menu-mobile__link${0}" data-testid="logout" type-style="body-3"${2}>${"t1"}</a>`;
const stc0 = {
  classMap: {
    "user-menu-mobile__top-section": true
  },
  key: 1
};
const stc1 = {
  "user-menu-mobile__avatar": true
};
const stc2 = {
  classMap: {
    "user-menu-mobile__links": true
  },
  key: 9
};
const stc3 = {
  "type": "loginNavLink"
};
const stc4 = {
  classMap: {
    "user-menu-mobile__bottom-section": true
  },
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, k: api_key, b: api_bind, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [$cmp.showUser ? api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    key: 0
  }, [api_element("div", stc0, [!$cmp.hideTitle ? api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.title))]) : null, api_custom_element("wds-avatar", _wdsAvatar, {
    classMap: stc1,
    props: {
      "src": $cmp.profileImage,
      "alt": "",
      "size": "medium"
    },
    key: 4
  }), $cmp.hideTitle ? api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.profileName))]) : null, !$cmp.hideTitle ? api_static_fragment($fragment3, 8, [api_static_part(1, null, api_dynamic_text($cmp.profileName))]) : null, api_element("div", stc2, api_iterator($cmp.mainMenuItems, function (item) {
    return api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc3,
      key: api_key(10, item.id),
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
      }
    }, [api_custom_element("wds-link", _wdsLink, {
      props: {
        "label": item.text,
        "href": item.link
      },
      key: 11
    }, [api_static_fragment($fragment4, 13, [api_static_part(0, {
      attrs: {
        "href": item.link,
        "data-testid": item.id
      }
    }, null), api_static_part(1, null, api_dynamic_text(item.text))])])]);
  }))]), api_static_fragment($fragment5, 15), $cmp.logoutItem ? api_element("div", stc4, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc3,
    key: 17,
    on: {
      "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleAnalytics))
    }
  }, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.logoutItem.text,
      "href": $cmp.logoutItem.link
    },
    key: 18
  }, [api_static_fragment($fragment6, 20, [api_static_part(0, {
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleLogoutClick))
    },
    attrs: {
      "href": $cmp.logoutItem.link
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.logoutItem.text))])])])]) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-694asf2nijv";
tmpl.legacyStylesheetToken = "undefined-_userMenuMobile";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
